module.exports = __webpack_public_path__ + "2128cead0c12cd40bbee7746e4561b20.jpg";